var map = {
	"./account_balance.svg": 11228,
	"./amber-exclamation.svg": 42572,
	"./back.svg": 72298,
	"./brand/cb-payments.svg": 11784,
	"./brand/cv-logo-white.svg": 25576,
	"./brand/cv-logomask-primary.svg": 11289,
	"./calender.svg": 11800,
	"./cancel.svg": 58488,
	"./check.svg": 87396,
	"./check_circle.svg": 43366,
	"./clipboard.svg": 63973,
	"./close.svg": 71466,
	"./credit_card.svg": 78250,
	"./dashboard.svg": 29584,
	"./documentation.svg": 8363,
	"./download.svg": 1116,
	"./dropdown.svg": 19220,
	"./email.svg": 59344,
	"./error-circle.svg": 22058,
	"./error-notification.svg": 60382,
	"./error.svg": 95435,
	"./green-tick.svg": 31932,
	"./info-outline-blue.svg": 21664,
	"./info-outline.svg": 1425,
	"./info.svg": 34538,
	"./left_arrow.svg": 67107,
	"./legal.svg": 30517,
	"./lock.svg": 19658,
	"./onboarding-status-graphic.svg": 74568,
	"./onboarding-success.svg": 62424,
	"./orang-exclamation-triangle.svg": 67792,
	"./orange-exclamation.svg": 27202,
	"./payment_acceptance_rate.svg": 75528,
	"./person.svg": 92291,
	"./question.svg": 16035,
	"./red-exclamation.svg": 2889,
	"./red-info.svg": 5826,
	"./right_arrow.svg": 21480,
	"./search.svg": 10322,
	"./search_clear.svg": 1018,
	"./spinner.svg": 47304,
	"./support.svg": 5914,
	"./tick.svg": 71005,
	"./total_active_customers.svg": 70393,
	"./transactions.svg": 30793,
	"./vertical_line.svg": 48604,
	"./view_column.svg": 85023,
	"./warning.svg": 92096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76153;